import axios from 'axios';
import { apiUrl } from '../..';

export const postRecordKeuntungan = (idbarang,nominal,token) => (dispatch)=>{
    dispatch({
        type:'FETCH RECORD KEUNTUNGAN'
    })
    const data =new URLSearchParams();
    data.append('idbarang',idbarang);
    data.append('nominal',nominal);
    axios.post(`${apiUrl.url}v1/suryaharapan/record/`,data,{
        headers:{
            'Authorization':`Bearer ${token}`,
            'content-type':'application/x-www-form-urlencoded'
        }
    })
    .then(res=>{
        const ResponseAPI = res.data;
        dispatch({
            type:'SUCCESS POST RECORD KEUNTUNGAN',
            payload:ResponseAPI.message,
            })
    })
    .catch(error=>{
        if(error.response){
            const ResponseError = error.response.data;
            dispatch({
                    type:'FAILED POST RECORD KEUNTUNGAN',
                    payload:ResponseError.message
                })
        }else if(error.request){
            dispatch({
                    type:'FAILED POST RECORD KEUNTUNGAN',
                    payload:'Disconnect from server'
            })
        }
    })
}